import request from '@/utils/request'
// 联系我们
export function connentUs() {
    return request({
        url: '/user/index/contactUsList',
        method: 'get',
    })
}
